import React, { Fragment, Suspense } from 'react'

import { Routes, Route, Navigate } from 'react-router-dom'

import { CustomLoaderOverlay } from '../components/LoaderOverlay'
import { IAppRouteSetting } from '../types'

import { AdminDashboardRoutes, AuthenticatedRoutes, NonAuthenticatedRoutes } from './AppRoutes'
import { APP_PATHS } from './paths'

type RenderRoutesPropsType = {
  routeSettings: IAppRouteSetting[]
}

export const RenderRoutes: React.FC<RenderRoutesPropsType> = ({ routeSettings = [] }) => {
  return (
    <Suspense fallback={<CustomLoaderOverlay />}>
      <Routes>
        {routeSettings.map((route, i) => {
          const Component = route.component
          const Guard = route.guard || Fragment
          const Layout = route.layout || Fragment
          return (
            <Route
              key={i}
              path={route.exact ? `${route.path}/*` : route.path}
              element={
                <Guard>
                  <Layout>
                    {route.routes ? (
                      <RenderRoutes routeSettings={route.routes} />
                    ) : Component ? (
                      <Component />
                    ) : undefined}
                  </Layout>
                </Guard>
              }
            />
          )
        })}
        <Route path="*" element={<Navigate to={APP_PATHS.auth} />} />
      </Routes>
    </Suspense>
  )
}

export const AppRoutesSettings: IAppRouteSetting[] = [
  ...NonAuthenticatedRoutes,
  ...AuthenticatedRoutes,
  ...AdminDashboardRoutes,
]
